<template>
	<div
		class="con-upload"
		:class="[
			{'disabled' : isDisabled}
		]"
	>
		<view-upload-custom
			v-if="viewActive"
			:src="viewSrc"
		/>
		<div class="con-img-upload">
			<!-- <transition-group v-for="(img,index) in getFilesFilter" :key="index" name="upload"> -->
			<div
				v-for="(img,index) in (keepRemoved ? getFilesFilter : srcs)"
				:class="{
					'fileError':img.error,
					'removeItem':keepRemoved && itemRemove.includes(index)
				}"
				:key="index"
				class="img-upload"
			>
				<button
					v-if="showStar"
					class="btn-x-file-star"
					type="button"
					@click="!isDisabled && !img.star && starFile(img)"
					:disabled="isDisabled"
					:class="{
						'active':img.star,
					}"
				>
					<i
						translate="no"
						class="material-icons notranslate"
					>star</i>
				</button>
				<button
					class="btn-x-file"
					type="button"
					:disabled="isDisabled"
					@click="!isDisabled && (keepRemoved ? removeFile(index) : removeFileObject(img))"
				>
					<i
						translate="no"
						class="material-icons notranslate"
					>
						clear
					</i>
				</button>
				<div class="button-footer">
					<button
						class="btn-x-file-move move-left fa6"
						type="button"
						v-if="allowMove && (keepRemoved ? getFilesFilter : srcs) && (keepRemoved ? getFilesFilter.length > 1 : srcs.length > 1) && (keepRemoved ? img.order > 1 : index > 0)"
						:disabled="isDisabled"
						@click="!isDisabled && moveUp(img, index)"
					>
						<i class="fa fa-solid fa-angles-left"></i>
					</button>
					<span
						v-else
						class="btn-x-file-move move-left fa6"
					></span>
					<span class="upload-order">{{img.order}}</span>
					<button
						class="btn-x-file-move move-right fa6"
						type="button"
						v-if="allowMove && (keepRemoved ? getFilesFilter : srcs) && (keepRemoved ? getFilesFilter.length > 1 : srcs.length > 1) && (index+1) < (keepRemoved ? getFilesFilter.length : srcs.length) "
						:disabled="isDisabled"
						@click="!isDisabled && moveDown(img, index)"
					>
						<i class="fa fa-solid fa-angles-right"></i>
					</button>
					<span
						v-else
						class="btn-x-file-move move-right fa6"
					></span>
				</div>
				<button
					:disabled="isDisabled || adicionarDisabled"
					v-if="showUploadButton"
					:class="{
						'on-progress':img.percent,
						'ready-progress':img.percent >= 100
					}"
					:style="{
						height: `${img.percent}%`
					}"
					class="btn-upload-file"
					@click="!isDisabled || adicionarDisabled && upload(index)"
				>
					<i
						translate="no"
						class="material-icons notranslate"
					>
						{{ img.percent >= 100?img.error?'report_problem':'cloud_done':'cloud_upload' }}
					</i>
					<span>{{ img.percent }} %</span>
				</button>
				<img
					v-if="img.src"
					:style="{
						maxWidth:img.orientation == 'h'?'100%':'none',
						maxHeight:img.orientation == 'w'?'100%':'none'
					}"
					:key="index"
					:src="img.src"
					@touchend="viewImage(img.src,$event)"
					@click="!isDisabled && viewImage(img.src,$event)"
				>
				<h4
					v-if="!img.src"
					class="text-archive"
					:class="{
						'video': previewVideo && img.fileObj && img.fileObj.type && img.type == 'video',
						'audio': previewVideo && img.fileObj && img.fileObj.type && img.type == 'audio',
					}"
				>
					<i
						translate="no"
						class="material-icons notranslate"
						v-if="!previewVideo"
					>
						description
					</i>
					<span v-if="!previewVideo">
						{{ img.name }}
					</span>
					<video
						v-if="previewVideo && img.fileObj && img.fileObj.type && img.type == 'video'"
						:id="'video-preview_'+index"
						muted
						loop
						playsinline
						preload="metadata"
						:src="previewVideoDataSrc(img, index)"
						:type="img.fileObj.type"
						@loadedmetadata="previewVideoLoaded($event, index, img)"
						:disabled="isDisabled"
					></video>
					<audio
						:disabled="isDisabled"
						v-if="previewVideo && img.fileObj && img.fileObj.type && img.type == 'audio'"
						:id="'audio-preview_'+index"
						muted
						loop
						playsinline
						controls
						controlslist="noplaybackrate nodownload"
						preload="metadata"
						:src="previewVideoDataSrc(img, index)"
						:type="img.fileObj.type"
						@loadedmetadata="previewAudioLoaded($event, index, img)"
					></audio>
				</h4>
			</div>
			<!-- </transition-group > -->
			<div
				:class="{
					'on-progress-all-upload':percent != 0,
					'is-ready-all-upload':percent >= 100,
					'disabled-upload':isDisabled || adicionarDisabled || $attrs.hasOwnProperty('disabled') || limit?(srcs.length - (keepRemoved ? itemRemove.length : 0)) >= Number(limit):false
				}"
				class="con-input-upload"
			>
				<input
					ref="fileInput"
					v-bind="$attrs"
					:disabled="isDisabled || adicionarDisabled || $attrs.disabled ? true : (limit?(srcs.length - (keepRemoved ? itemRemove.length : 0)) >= Number(limit):false)"
					type="file"
					@change="getFiles"
				>
				<span class="text-input">
					{{ text }}
				</span>
				<span
					:style="{
						width:`${percent}%`
					}"
					class="input-progress"
				>
				</span>
				<button
					v-if="showUploadButton"
					:disabled="filesx.length == 0 || isDisabled || adicionarDisabled"
					type="button"
					title="Upload1"
					class="btn-upload-all vs-upload--button-upload"
					@click="!isDisabled || adicionarDisabled && upload('all')"
				>
					<i
						translate="no"
						class="material-icons notranslate"
					>
						cloud_upload
					</i>
				</button>
				<button
					v-if="!showUploadButton"
					type="button"
					title="Upload2"
					:disabled="isDisabled || adicionarDisabled"
					class="btn-upload-all vs-upload--button-upload"
					@click="!isDisabled || adicionarDisabled && $refs.fileInput.click($event)"
				>
					<span
						class="text-input"
						v-if="textUpload"
					>
						{{ textUpload }}
					</span>
					<i
						v-else
						translate="no"
						class="material-icons notranslate"
					>
						cloud_upload
					</i>
				</button>
			</div>
		</div>
	</div>
</template>
<script>
import viewUploadCustom from "./viewUploadCustom";
var lastTap = 0;
export default {
	name: "VsUploadCustom",
	components: {
		viewUploadCustom,
	},
	inheritAttrs: false,
	props: {
		fileName: {
			default: null,
			type: String,
		},
		text: {
			default: "Upload File",
			type: String,
		},
		textUpload: {
			default: "",
			type: String,
		},
		textMax: {
			default: "Maximum of files reached",
			type: String,
		},
		limit: {
			default: null,
			type: [Number, String],
		},
		videoDuraction: {
			default: null,
			type: [Number, String],
		},
		videoDuractionText: {
			default: null,
			type: String,
		},
		videoDuractionMin: {
			default: null,
			type: [Number, String],
		},
		videoDuractionTextMin: {
			default: null,
			type: String,
		},
		action: {
			default: null,
			type: String,
		},
		headers: {
			default: null,
			type: Object,
		},
		data: {
			default: null,
			type: Object,
		},
		automatic: {
			default: false,
			type: Boolean,
		},
		showUploadButton: {
			default: true,
			type: Boolean,
		},
		singleUpload: {
			default: false,
			type: Boolean,
		},
		keepRemoved: {
			default: true,
			type: Boolean,
		},
		allowMove: {
			default: false,
			type: Boolean,
		},
		previewVideo: {
			default: false,
			type: Boolean,
		},
		showStar: {
			default: false,
			type: Boolean,
		},
		isDisabled: {
			default: false,
			type: Boolean,
		},
		adicionarDisabled: {
			default: false,
			type: Boolean,
		},
	},
	data: () => ({
		inputValue: null,
		type: null,
		srcs: [],
		filesx: [],
		itemRemove: [],
		percent: 0,
		viewActive: false,
		viewSrc: null,
	}),
	computed: {
		getFilesFilter: {
			cache: false,
			get() {
				let files = this.srcs.filter((item) => {
					return !item.hasOwnProperty("remove") || !item.remove;
				});
				files.sort((a, b) => a.order - b.order);
				//files.sort((a, b) => (a.star ? -1 : 0));
				return files;
			},
		},
		/*getFilesFilter() {
			let files = this.srcs.filter((item) => {
				return !item.hasOwnProperty("remove") || !item.remove;
			});
			files.sort((a, b) => a.order - b.order);
			//files.sort((a, b) => (a.star ? -1 : 0));
			return files;
		},*/
		postFiles() {
			let postFiles = Array.prototype.slice.call(this.filesx);
			postFiles = postFiles.filter((item) => {
				return !item.hasOwnProperty("remove") || !item.remove;
			});
			return postFiles.length;
		},
	},
	watch: {
		percent() {
			if (this.percent >= 100) {
				this.srcs.forEach((file) => {
					file.percent = 100;
				});
				setTimeout(() => {
					this.percent = 0;
				}, 1000);
			}
		},
	},
	methods: {
		previewVideoLoaded(evt, index, img) {
			//console.log("previewVideoLoaded", ...arguments);
			if (evt && evt.srcElement && evt.srcElement instanceof HTMLVideoElement) {
				/*console.log(evt.srcElement.videoHeight, evt.srcElement.height);
				console.log(evt.srcElement.videoWidth, evt.srcElement.width);*/
				if (
					this.videoDuraction != null &&
					this.videoDuraction > 0 &&
					this.videoDuractionText &&
					evt.srcElement.duration > this.videoDuraction
				) {
					/*this.$vs.dialog({
						color: "danger",
						title: "Vídeo inválido",
						text: "Vídeo deve ter no máximo 1 minuto de duração.",
					});*/
					//console.log(evt.srcElement.duration);
					this.$vs.notify({
						title: "Vídeo inválido",
						text: "Vídeo deve ter no máximo " + this.videoDuractionText + " de duração.",
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						time: 4000,
					});
					if (this.keepRemoved) {
						this.removeFile(index);
					} else {
						this.removeFileObject(img);
					}
				} else if (evt.srcElement.videoHeight < 350) {
					this.$vs.notify({
						title: "Vídeo inválido",
						text: "Vídeo deve ter no mínimo 350 pixeis de altura.",
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						time: 4000,
					});
					if (this.keepRemoved) {
						this.removeFile(index);
					} else {
						this.removeFileObject(img);
					}
				} else if (evt.srcElement.videoWidth < 196) {
					this.$vs.notify({
						title: "Vídeo inválido",
						text: "Vídeo deve ter no mínimo 196 pixeis de largura.",
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						time: 4000,
					});
					if (this.keepRemoved) {
						this.removeFile(index);
					} else {
						this.removeFileObject(img);
					}
				}
			}
		},
		previewAudioLoaded(evt, index, img) {
			//console.log("previewVideoLoaded", ...arguments);
			if (evt && evt.srcElement && evt.srcElement instanceof HTMLAudioElement) {
				/*console.log(evt.srcElement.videoHeight, evt.srcElement.height);
				console.log(evt.srcElement.videoWidth, evt.srcElement.width);*/
				if (
					this.videoDuraction != null &&
					this.videoDuraction > 0 &&
					this.videoDuractionText &&
					evt.srcElement.duration > this.videoDuraction
				) {
					/*this.$vs.dialog({
						color: "danger",
						title: "Vídeo inválido",
						text: "Vídeo deve ter no máximo 1 minuto de duração.",
					});*/
					//console.log(evt.srcElement.duration);
					this.$vs.notify({
						title: "Audio inválido",
						text: "Audio deve ter no máximo " + this.videoDuractionText + " de duração.",
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						time: 4000,
					});
					if (this.keepRemoved) {
						this.removeFile(index);
					} else {
						this.removeFileObject(img);
					}
				} else if (
					this.videoDuractionMin != null &&
					this.videoDuractionMin > 0 &&
					this.videoDuractionTextMin &&
					evt.srcElement.duration < this.videoDuractionMin
				) {
					//console.log(evt.srcElement.duration);
					this.$vs.notify({
						title: "Audio inválido",
						text: "Audio deve ter no mínimo " + this.videoDuractionTextMin + " de duração.",
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						time: 4000,
					});
					if (this.keepRemoved) {
						this.removeFile(index);
					} else {
						this.removeFileObject(img);
					}
				}
			}
		},
		previewVideoDataSrc(img, index) {
			//console.log("previewVideoDataSrc", ...arguments, this.$refs);
			//console.log("previewVideoDataSrc", this.$el);
			var self = this;
			var reader = new FileReader();
			reader.addEventListener("load", function() {
				/*console.log(
					"loaded",
					window.document.getElementById("video-preview_" + index.toString()),
					window.jQuery(self.$el),
					window.jQuery("#video-preview_" + index.toString(), window.jQuery(self.$el))
				);*/
				//if (window.document.getElementById("video-preview_" + index.toString())) {
				if (window.jQuery("#video-preview_" + index.toString(), window.jQuery(self.$el)).length == 1) {
					self.$nextTick(function() {
						/*console.log(
							"loadedaaaaa",
							window.document.getElementById("video-preview_" + index.toString()),
							window.jQuery(self.$el),
							window.jQuery("#video-preview_" + index.toString(), window.jQuery(self.$el))
						);*/
						//console.log("loadedOK", self.$refs);
						//window.document.getElementById("video-preview_" + index.toString()).src = reader.result;
						window.jQuery("#video-preview_" + index.toString(), window.jQuery(self.$el))[0].src = reader.result;
						reader = null;
					});
					//} else if (window.document.getElementById("audio-preview_" + index.toString())) {
				} else if (window.jQuery("#audio-preview_" + index.toString(), window.jQuery(self.$el)).length == 1) {
					self.$nextTick(function() {
						//console.log("loadedOK", self.$refs);
						//window.document.getElementById("audio-preview_" + index.toString()).src = reader.result;
						window.jQuery("#audio-preview_" + index.toString(), window.jQuery(self.$el))[0].src = reader.result;
						reader = null;
					});
				} else {
					reader = null;
				}
			});
			reader.readAsDataURL(img.fileObj);
			return null;
		},
		/*previewVideoData(evt, img, index) {
			console.log("previewVideoData", ...arguments);
			var self = this;
			var target = evt.target;
			var reader = new FileReader();
			reader.readAsDataURL(img.fileObj);
			reader.addEventListener("load", function() {
				target.src = reader.result;
				/*if (
					self.$refs &&
					self.$refs.hasOwnProperty("uploadVideoPlayer" + index.toString()) &&
					self.$refs["uploadVideoPlayer" + index.toString()]
				) {
					self.$refs["uploadVideoPlayer" + index.toString()].src = reader.result;
				}* /
			});
		},*/
		moveUp(img, index) {
			if (this.isDisabled) {
				return;
			}
			//console.log("moveUP", img, img.order, index);
			if (index >= 1) {
				//console.log("movedUP");
				this.srcs[index].star = false;
				this.srcs = this.moveArrayItem(this.srcs, index, index - 1);
				for (const file in this.srcs) {
					this.srcs[file].order = parseInt(file) + 1;
					if (file == 0) {
						this.srcs[file].star = true;
					} else {
						this.srcs[file].star = false;
					}
					//console.log("file", file, this.srcs[file], this.srcs[file].order);
				}
				this.$nextTick(() => {
					this.$forceUpdate();
				});
			}
		},
		moveDown(img, index) {
			if (this.isDisabled) {
				return;
			}
			//console.log("moveDown", img, img.order, index);
			if (index + 1 < this.srcs.length) {
				//console.log("movedDown");
				if (index == 0) {
					this.srcs[index].star = false;
				}
				this.srcs = this.moveArrayItem(this.srcs, index, index + 1);
				for (const file in this.srcs) {
					this.srcs[file].order = parseInt(file) + 1;
					if (file == 0) {
						this.srcs[file].star = true;
					} else {
						this.srcs[file].star = false;
					}
					//console.log("file", file, this.srcs[file], this.srcs[file].order);
				}
				this.$nextTick(() => {
					this.$forceUpdate();
				});
			}
		},
		viewImage(src, evt) {
			if (this.isDisabled) {
				return;
			}
			var timeout;

			var eventx = "ontouchstart" in window || (window.DocumentTouch && document instanceof window.DocumentTouch) ? "touchstart" : "click";
			if (eventx == "click") {
				this.viewActive = true;
				this.viewSrc = src;
			} else {
				if (evt.type == "touchend") {
					var currentTime = new Date().getTime();
					var tapLength = currentTime - lastTap;
					clearTimeout(timeout);
					if (tapLength < 500 && tapLength > 0) {
						this.viewActive = true;
						this.viewSrc = src;
						event.preventDefault();
					}
					lastTap = currentTime;
				}
			}
		},
		starFile(img) {
			if (this.isDisabled) {
				return;
			}
			if (this.srcs && this.srcs.length > 1) {
				var move = false;
				var index = null;
				for (var idx in this.srcs) {
					//console.log(idx, this.srcs[idx], img == this.srcs[idx]);
					if (img == this.srcs[idx] && !this.srcs[idx].star) {
						for (var idxSub in this.srcs) {
							this.srcs[idxSub].star = false;
						}
						this.srcs[idx].star = true;
						if (idx >= 1) {
							move = true;
							index = idx;
						}
						break;
					}
				}
				if (move) {
					//console.log("move", index, this.srcs[index], this.srcs[0]);
					var first = Object.assign({}, this.srcs[0]);
					this.srcs[0] = Object.assign({}, this.srcs[index]);
					this.srcs[index] = Object.assign({}, first);
					//this.srcs = this.moveArrayItem(this.srcs, index, 0);
					for (const file in this.srcs) {
						this.srcs[file].order = parseInt(file) + 1;
						//console.log("file", file, this.srcs[file], this.srcs[file].order);
					}
					this.$nextTick(() => {
						this.$forceUpdate();
					});
				}
			}
		},
		removeFile(index) {
			if (this.isDisabled) {
				return;
			}
			this.itemRemove.push(index);
			this.$emit("on-delete", this.filesx[index]);
			setTimeout(() => {
				this.filesx[index].remove = true;
			}, 301);
		},
		array_move(arr, old_index, new_index) {
			if (new_index >= arr.length) {
				var k = new_index - arr.length + 1;
				while (k--) {
					arr.push(undefined);
				}
			}
			arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
			return arr; // for testing
		},
		moveArrayItem(array, moveIndex, toIndex) {
			/* #move - Moves an array item from one position in an array to another.
				Note: This is a pure function so a new array will be returned, instead
				of altering the array argument.

				Arguments:
				1. array     (String) : Array in which to move an item.         (required)
				2. moveIndex (Object) : The index of the item to move.          (required)
				3. toIndex   (Object) : The index to move item at moveIndex to. (required)
			*/
			const item = array[moveIndex];
			const length = array.length;
			const diff = moveIndex - toIndex;

			if (diff > 0) {
				// move left
				return [...array.slice(0, toIndex), item, ...array.slice(toIndex, moveIndex), ...array.slice(moveIndex + 1, length)];
			} else if (diff < 0) {
				// move right
				const targetIndex = toIndex + 1;
				return [...array.slice(0, moveIndex), ...array.slice(moveIndex + 1, targetIndex), item, ...array.slice(targetIndex, length)];
			}
			return array;
		},
		removeFileObject(img) {
			if (this.isDisabled) {
				return;
			}
			/*console.log(
				"removeFileObject",
				img,
				img.fileObj,
				this.srcs.filter((item) => {
					return item === img;
				}),
				this.filesx.filter((item) => {
					return item === img.fileObj;
				})
			);*/
			this.filesx = this.filesx.filter((item) => {
				return item !== img.fileObj;
			});
			this.srcs = this.srcs.filter((item) => {
				return item !== img;
			});
			for (const file in this.srcs) {
				this.srcs[file].order = parseInt(file) + 1;
			}
			this.$emit("on-delete", img);
		},
		getFiles(e) {
			this.$emit("update:vsFile", e.target.value);
			let _this = this;
			function uploadImage(e) {
				let orientation = "h";
				var image = new Image();
				image.fileObject = this.fileObject;
				image.src = e.target.result;
				image.onload = function() {
					if (this.width > this.height) {
						orientation = "w";
					}
					switchImage(this, orientation);
				};
			}
			function switchImage(image, orientation) {
				_this.srcs.push({
					src: image.src,
					orientation: orientation,
					type: _this.typex,
					percent: null,
					error: false,
					remove: null,
					fileObj: image.fileObject,
					order: _this.srcs.length + 1,
					star: _this.srcs.length > 0 ? false : true,
				});
			}

			var files = e.target.files;
			let count = this.srcs.length - (this.keepRemoved ? this.itemRemove.length : 0);
			for (const file in files) {
				if (files.hasOwnProperty(file)) {
					if (this.limit) {
						count++;
						if (count > Number(this.limit)) {
							break;
						}
					}

					const filex = files[file];
					if (/image.*/.test(filex.type)) {
						this.typex = "image";
						this.filesx.push(filex);
						var reader = new FileReader();
						reader.fileObject = filex;
						reader.onload = uploadImage;
						reader.readAsDataURL(filex);
					} else if (/video.*/.test(filex.type)) {
						this.typex = "video";
						this.filesx.push(filex);
						_this.srcs.push({
							src: null,
							name: filex.name,
							type: "video",
							percent: null,
							error: false,
							remove: null,
							fileObj: filex,
							order: _this.srcs.length + 1,
							star: _this.srcs.length > 0 ? false : true,
						});
					} else if (/audio.*/.test(filex.type)) {
						//console.log("audio", filex);
						this.typex = "audio";
						this.filesx.push(filex);
						_this.srcs.push({
							src: null,
							name: filex.name,
							type: "audio",
							percent: null,
							error: false,
							remove: null,
							fileObj: filex,
							order: _this.srcs.length + 1,
							star: _this.srcs.length > 0 ? false : true,
						});
					} else {
						this.filesx.push(filex);
						_this.srcs.push({
							src: null,
							name: filex.name,
							percent: null,
							error: false,
							remove: null,
							fileObj: filex,
							order: _this.srcs.length + 1,
							star: _this.srcs.length > 0 ? false : true,
						});
					}
					this.$emit("change", e.target.value, this.filesx);
				}
			}
			const input = this.$refs.fileInput;
			input.type = "text";
			input.type = "file";

			if (this.automatic) {
				this.upload("all");
			}
		},
		upload(index) {
			if (this.isDisabled || this.adicionarDisabled) {
				return;
			}
			const formData = new FormData();
			let postFiles = Array.prototype.slice.call(this.filesx);
			if (typeof index == "number") {
				postFiles = [postFiles[index]];
			} else if (index == "all") {
				postFiles = postFiles.filter((item) => {
					return !item.hasOwnProperty("remove") || !item.remove;
				});
			}

			const data = this.data || {};
			for (var key in data) {
				formData.append(key, data[key]);
			}

			if (this.singleUpload) {
				if (postFiles && postFiles.length > 0) {
					postFiles.forEach((filex) => {
						const formData = new FormData();
						for (var key in data) {
							formData.append(key, data[key]);
						}
						formData.append(this.fileName, filex, filex.name);

						this.uploadx(index, formData);
					});
				} else {
					const formData = new FormData();
					for (var key in data) {
						formData.append(key, data[key]);
					}
					this.uploadx(index, formData);
				}
			} else {
				if (postFiles && postFiles.length > 0) {
					postFiles.forEach((filex) => {
						formData.append(this.fileName, filex, filex.name);
					});
				}
				this.uploadx(index, formData);
			}
		},
		uploadx(index, formData) {
			let self = this;
			const xhr = new XMLHttpRequest();

			xhr.onerror = function error(e) {
				self.$emit("on-error", e);
				if (typeof index == "number") {
					self.srcs[index].error = true;
				}
			};

			xhr.onload = function onload(e) {
				if (xhr.status < 200 || xhr.status >= 300) {
					self.$emit("on-error", e);
					if (typeof index == "number") {
						self.srcs[index].error = true;
					}
				} else {
					self.$emit("on-success", e);
				}
			};

			if (xhr.upload) {
				xhr.upload.onprogress = function progress(e) {
					if (e.total > 0) {
						let percent = (e.loaded / e.total) * 100;
						if (typeof index == "number") {
							self.srcs[index].percent = Math.trunc(percent);
						} else {
							self.percent = Math.trunc(percent);
						}
					}
				};
			}

			xhr.withCredentials = true;

			xhr.open("POST", this.action, true);

			const headers = this.headers || {};

			for (let head in headers) {
				if (headers.hasOwnProperty(head) && headers[head] !== null) {
					xhr.setRequestHeader(head, headers[head]);
				}
			}

			xhr.send(formData);
		},
	},
};
</script>
<style lang="scss">
.con-upload.disabled,
.con-upload:disabled {
	.con-img-upload .img-upload .btn-x-file-star {
		cursor: default;
		pointer-events: none;
	}
	.con-img-upload .img-upload .button-footer {
		cursor: default;
		pointer-events: none;
	}
	.con-img-upload .img-upload .button-footer .btn-x-file-move {
		cursor: default;
		pointer-events: none;
	}
	.con-img-upload .img-upload .button-footer .upload-order {
		cursor: default;
		pointer-events: none;
	}
	.con-input-upload input {
		cursor: default;
		pointer-events: none;
	}
}

.con-img-upload .img-upload .btn-x-file-star {
	display: block;
	position: absolute;
	top: 5px;
	left: 5px;
	padding: 0;
	margin: 0;
	-webkit-transform: translate(20%, -20%);
	transform: translate(20%, -20%);
	background: transparent;
	z-index: 300;
	opacity: 0;
	border: 0;
	cursor: pointer;
	-webkit-transition: all 0.2s ease;
	transition: all 0.2s ease;
	border-radius: 10px;
}
.con-img-upload .img-upload .btn-x-file-star.active {
	cursor: default;
}
.con-img-upload .img-upload:hover .btn-x-file-star {
	opacity: 1;
	-webkit-transform: translate(0);
	transform: translate(0);
}
.con-img-upload .img-upload .btn-x-file-star i {
	-webkit-transition: all 0.2s ease;
	transition: all 0.2s ease;
	position: relative;
	padding: 4px;
	font-size: 1.4rem;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	border-radius: 5px;
	background: rgba(0, 0, 0, 0.1);
	color: #fff;
	text-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);
}
.con-img-upload .img-upload:hover .btn-x-file-star.active i {
	border-radius: 50%;
	background: rgba(var(--vs-warning), 1);
}
.con-img-upload .img-upload .btn-x-file-star:hover i {
	border-radius: 50%;
	background: rgba(var(--vs-warning), 1);
}
.con-img-upload .img-upload .button-footer {
	border: 0;
	border-radius: 0;
	bottom: 0px;
	cursor: pointer;
	display: flex;
	margin: 0;
	padding: 2px;
	position: absolute;
	transition: all 0.2s ease;
	z-index: 300;
	left: 0px;
	right: 0px;
	background-color: #ca1e25;
	transform: unset;
}
.con-img-upload .img-upload .button-footer .btn-x-file-move {
	display: block;
	padding: 2px;
	margin: 0;
	-webkit-transform: unset;
	transform: unset;
	z-index: 300;
	border: 0;
	cursor: pointer;
	-webkit-transition: all 0.2s ease;
	transition: all 0.2s ease;
	border-radius: 0px;
	font-size: 22px;
	flex: 1;
}
.con-img-upload .img-upload .button-footer .upload-order {
	display: block;
	padding: 2px;
	margin: 0;
	-webkit-transform: unset;
	transform: unset;
	z-index: 300;
	border: 0;
	cursor: pointer;
	-webkit-transition: all 0.2s ease;
	transition: all 0.2s ease;
	border-radius: 0px;
	font-size: 20px;
	flex: 2;
	text-align: center;
}
.con-img-upload .img-upload .text-archive.video {
	width: 100%;
	padding: 0px;
	margin: 0px;
	position: absolute;
	top: 0px;
	bottom: calc(0px + 31px);
}
.con-img-upload .img-upload .text-archive.video video {
	align-self: flex-start;
	width: 100%;
	/*height: 100%;*/
}
.con-img-upload .img-upload .text-archive.audio {
	width: 100%;
	padding: 0px;
	margin: 0px;
	position: absolute;
	top: 0px;
	bottom: calc(0px + 31px);
}
.con-img-upload .img-upload .text-archive.audio audio {
	align-self: center;
	width: 100%;
	/*height: 100%;*/
}
</style>
